import { FETCH_COUPON_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
  selectList: [],
};

const couponListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COUPON_LIST:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default couponListReducer;
